/** @jsx dom */
import bus from '@viskan/bus';
import Button from '@viskan/deku-button';
import {Form, CheckboxField} from '@viskan/deku-form';
import debounce from 'debounce';
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import page from 'page';
import keyReplace from 'key-replace';
import submitForm from 'submitform';
import Customer from './customer';
import Terms from './terms';

const propTypes = {
	getTranslation: {
		source: 'getTranslation'
	},
	openPopup: {
		source: 'openPopup'
	},
	shopcart: {
		source: 'shopcart'
	},
	site: {
		source: 'site'
	}
};

const defaultProps = {
	checkout: {
		deliveryMethods: [],
		paymentMethods: []
	}
};

const handleError = (error, openPopup) => {
	bus.emit('loading:close');

	if (error.response && error.response.statusCode === 500) {
		v12.util.error(error);
		return;
	}

	const message = typeof error.message === 'string' ? <div innerHTML={error.message}/> : error.message;

	openPopup(message);
};

const onSubmit = ({checkout, customer, router, shopcart, site, openPopup}) => formData => {
	bus.emit('loading:open');

	const parsedData = {
		'del_country.id': site.country_id,
		'inv_country.id': site.country_id,
		'vis_country.id': site.country_id,
		'entry_id': '1',
		...keyReplace(formData, 'customer.', '')
	};

	bus.emit('loading:open');

	const serverCustomerData = parsedData;

	const nationalIdField = customer.person_flg ? 'socialSecurityNumber' : 'organizationNumber';
	const lastOrCompanyName = customer.person_flg ? 'lastName' : 'companyName';
	const contactOrFirstName = customer.person_flg ? 'firstName' : 'address.careOf';

	bus.emit('customer:update', serverCustomerData);

	v12.util.http.post('/api/purchases', {
		body: {
			[contactOrFirstName]: parsedData.cust_desc2,
			[lastOrCompanyName]: parsedData.cust_desc1,
			[nationalIdField]: parsedData.org_no,
			'address.addressLine1': parsedData.inv_address,
			'address.city': parsedData.inv_city,
			'address.countryCode': site.country_code,
			'address.zipcode': parsedData.inv_zipcode,
			cellphone: parsedData.phone_2,
			email: parsedData.email_1,
			integrities: checkout.integrities,
			pathPrefix: router.pathPrefix,
			shopcartId: shopcart.head.shopcart_id_str
		},
		query: v12.options.defaults
	}).then(payment => {
		const {parameters, submitURL, purchaseNumber} = payment.body;

		bus.emit('loading:close');

		if (submitURL && parameters.length > 0) {
			const formData = parameters.reduce((obj, item) => {
				obj[item.key] = item.value;
				return obj;
			}, {});

			submitForm(formData, {action: submitURL, method: 'POST'});
			return;
		}

		page(`${router.pathPrefix}receipt/${purchaseNumber}`);
	}).catch(error => handleError(error, openPopup));
};

const shouldUpdate = ({props}, nextProps) => !deepEqual(props, nextProps);

const render = ({props}) => {
	const {customer, getTranslation} = props;
	const onSetPerson = event => props.setPerson({
		isPerson: Boolean(event.target.value)
	});

	return (
		<section class='Vco Vco--dibsExact Vco--dibsReset Vco--dibsAlike'>
			{false && props.setPerson && <CheckboxField name='person_flg' label={getTranslation('b2b.person')} value='1' checked={customer.person_flg} onChange={onSetPerson}/>}
			<Form class='Vco-form Form--horizontal' onSubmit={debounce(onSubmit(props), 3000, true)}>
				<h2 class='Heading'>{getTranslation('vco.address_and_payment')}</h2>
				<Customer class='Vco-section' customer={customer} displayEmail/>
				<Terms/>
				<Button class='Button--primary Complete-order' type='submit'>{getTranslation('global.buy')}</Button>
			</Form>
		</section>
	);
};

export default {defaultProps, propTypes, render, shouldUpdate};
